/**
 * DB リセット後など、JWT は残るが auth.users に行が無いときの判定。
 * profiles への sync が FK 23503 で落ちる。
 */

type ErrorLike = {
  code?: string;
  message?: string;
  details?: string;
};

export function isStaleAuthUserError(error: unknown): boolean {
  const e = error as ErrorLike | null;
  if (!e || typeof e !== 'object') return false;
  if (e.code !== '23503') return false;
  const haystack = `${e.message ?? ''} ${e.details ?? ''}`;
  return (
    /profiles_id_fkey/i.test(haystack) ||
    /is not present in table ["']?users["']?/i.test(haystack)
  );
}
